import React from 'react';
import { useMapCanvas } from '../../contexts/MapCanvasContext';
import { useMapEditor } from '../../contexts/MapEditorContext';
import { ShapeToolbox } from './ShapeToolbox/ShapeToolbox';
import { ToolsPickerToolbar } from './ToolsPickerToolbar';
import { ResourceToolBox } from './ShapeToolbox/ResourceToolBox';

export const EditorToolbars: React.FC = () => {
  const {
    shapes,
    selectedIds,
    activeTool,
    updateShape,
    deleteShape,
    moveShape,
    setActiveTool,
    locateShape
  } = useMapEditor();

  const { stagePosition } = useMapCanvas();

  return (
    <>
      <div className="relative z-10">
        <ToolsPickerToolbar
          activeTool={activeTool}
          onToolChange={setActiveTool}
        />
        {selectedIds.length === 1 && (
          <ShapeToolbox
            shape={shapes.find((s) => s.id === selectedIds[0])!}
            stageScale={stagePosition.scale}
            onUpdate={updateShape}
            onDelete={() => deleteShape(selectedIds[0])}
            onLocate={() => locateShape(selectedIds[0])}
            onMoveUp={() => moveShape(selectedIds[0], 'up')}
            onMoveDown={() => moveShape(selectedIds[0], 'down')}
          />
        )}
        {selectedIds.length > 0 && (
          <ResourceToolBox
            shapes={
              shapes.filter(
                (s) => s.type === 'spot' && selectedIds.includes(s.id)
              ) || []
            }
          />
        )}
      </div>
    </>
  );
};
